export default __webpack_public_path__ + "static/media/logoCenter.953ed290.png";